// useTranslation.js içinde
import { useState, useEffect, createContext, useContext } from 'react';

// Dil context'i oluşturun
const LanguageContext = createContext();

// Provider bileşeni
export const LanguageProvider = ({ children }) => {
  // Varsayılan dil veya localStorage'dan alınan dil
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('lang') || 'en';
  });
  
  // Mevcut çeviriler
  const [translations, setTranslations] = useState({});
  
  // Dil dosyalarını yükle
  useEffect(() => {
    const loadTranslations = async () => {
      try {
        // Dil dosyasını dinamik olarak import et
        const module = await import(`../i18n/locales/${currentLanguage}.json`);
        setTranslations(module.default || module);
      } catch (error) {
        console.error('Dil dosyası yüklenirken hata:', error);
        // Hata durumunda İngilizce'ye döns
        if (currentLanguage !== 'en') {
          const enModule = await import('../i18n/locales/en.json');
          setTranslations(enModule.default || enModule);
        }
      }
    };
    
    loadTranslations();
  }, [currentLanguage]);
  
  // Dil değiştirme fonksiyonu
  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
    localStorage.setItem('lang', lang);
  };
  
  // Çeviri fonksiyonu
  const translate = (key) => {
    return translations.translations && translations.translations[key] 
      ? translations.translations[key] 
      : key;
  };
  
  return (
    <LanguageContext.Provider value={{ 
      currentLanguage, 
      changeLanguage, 
      translate, 
      languageInfo: translations 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook
export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation hook must be used within a LanguageProvider');
  }
  return context;
};
